import React, { Fragment } from "react";
import { Typography } from "../Typography";
import styled from "@emotion/styled";

export type FormSectionProps = {
  title?: string;
  children: Array<React.ReactNode> | React.ReactNode;
  hideBorder?: boolean;
  className?: string;
  rightTitleSlot?: React.ReactNode;
  ["data-testid"]?: string;
};

const Container = styled.section<{ hideBorder?: boolean }>`
  display: flex;
  flex-direction: column;
  background-color: transparent;
  width: 100%;
  height: auto;
  padding: 64px 0px;
  border-bottom: 4px solid
    ${({ theme, hideBorder }) =>
      hideBorder ? "transparent" : theme.colors.mist};
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const FormTitle = styled(Typography)`
  padding-bottom: 52px;
`;

const ContentWrapper = styled.div`
  margin-bottom: 43px;
`;

export const FormSection = ({
  title,
  children,
  hideBorder,
  rightTitleSlot,
  ...containerProps
}: FormSectionProps) => {
  // Always make sure the children is an array for ease
  const childrenArr = Array.isArray(children) ? children : [children];

  return (
    <Container hideBorder={hideBorder} {...containerProps}>
      <TitleContainer>
        {title && (
          <FormTitle as="h2" use="sectionTitle">
            {title}
          </FormTitle>
        )}
        {rightTitleSlot}
      </TitleContainer>
      {childrenArr.map((child, index) => {
        // If there is another component after this one aff the wrapper component
        if (childrenArr[index + 1]) {
          return <ContentWrapper key={index}>{child}</ContentWrapper>;
        }
        return <Fragment key={index}>{child}</Fragment>;
      })}
    </Container>
  );
};
